import React from 'react';
import Helmet from 'react-helmet';
import { MainNavigation, LegacyFooter, CookieAlert } from '@mondough/public-web-components';
import './global.scss';
import favicon from './static/favicon.png';
import globalMetaTagsArray from './variables/globalMetaTagsArray';
import generateMetaTags from './utils/generateMetatags';

export default ({ children }) => (
  <>
    <Helmet htmlAttributes={{ lang: 'en' }}>
      {generateMetaTags(globalMetaTagsArray)}
      <link
        {...{
          rel: 'shortcut icon',
          href: favicon,
          type: 'image/png',
        }}
      />
    </Helmet>
    <CookieAlert />
    <MainNavigation />
    <main role="main">{children}</main>
    <LegacyFooter />
  </>
);
